import config from '../config';
import ApiService from './ApiService';

class DashboardService {
  static async getDashboardMetrics(odmType = 'Bandwidth Upgrade/Downgrade') {
    try {
      const response = await fetch(`${config.apiUrl}/api/dashboard/metrics?odm_type=${encodeURIComponent(odmType)}`, {
        headers: await ApiService.getDefaultHeaders(),
      });
      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching dashboard metrics:', error);
      throw error;
    }
  }

  static async getStatusDistribution(odmType = 'Bandwidth Upgrade/Downgrade', oeName = '') {
    try {
      let url = `${config.apiUrl}/api/dashboard/status-distribution?odm_type=${encodeURIComponent(odmType)}`;
      if (oeName) url += `&oe_name=${encodeURIComponent(oeName)}`;
      const response = await fetch(url, {
        headers: await ApiService.getDefaultHeaders(),
      });
      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching status distribution:', error);
      throw error;
    }
  }

  static async getCountryDistribution(odmType = 'Bandwidth Upgrade/Downgrade') {
    try {
      const response = await fetch(`${config.apiUrl}/api/dashboard/country-distribution?odm_type=${encodeURIComponent(odmType)}`, {
        headers: await ApiService.getDefaultHeaders(),
      });
      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching country distribution:', error);
      throw error;
    }
  }

  static async getOEDistribution(odmType = 'Bandwidth Upgrade/Downgrade') {
    try {
      const response = await fetch(`${config.apiUrl}/api/dashboard/oe-distribution?odm_type=${encodeURIComponent(odmType)}`, {
        headers: await ApiService.getDefaultHeaders(),
      });
      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching OE distribution:', error);
      throw error;
    }
  }
}

export default DashboardService;
